import { isPostfixUnaryExpression } from 'typescript';
import * as ActionTypes from '../constants/action-types';
// import STEP from '../constants/app-step';
import WorkflowStep from '../constants/workflow-steps';

const initialState = {
    isPosting: false,
    conversationId: null,
    questionSetId: null,
    question: null,
    dataSuccess: false,
    dataFailure: false,
    fileUploadFailure: false,
    fullFailure: false,
    currentStep: WorkflowStep.PersonalData,
    timeOutFailure: null,
    ccpaModel: null,
    requestType: null,
    productType: null
};

const appReducers = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {
        case ActionTypes.ASYNC_LOADING:
            return { ...state, isPosting: true };

        case ActionTypes.POST_SUCCESS:
            return { ...state, isPosting: false };

        case ActionTypes.SET_REQUEST_TYPE:
            return { ...state, requestType: payload };

        case ActionTypes.AUTH_FAILURE:
            return { ...initialState, isPosting: false, currentStep: WorkflowStep.AuthFailure, ccpaModel: null };

        case ActionTypes.FILE_ERROR:
            return { ...initialState, isPosting: false, currentStep: WorkflowStep.FileError, fileUploadFailure: true };

        case ActionTypes.TIMEOUT_FAILURE:
            return { ...state, isPosting: false, currentStep: WorkflowStep.AuthFailure, timeOutFailure: true, ccpaModel: null };

        case ActionTypes.SET_QUESTIONS:
            return {
                ...state,
                isPosting: false,
                currentStep: WorkflowStep.Questions,
                conversationId: payload.conversationId,
                questionSetId: payload.questionSetId,
                question: {
                    ...payload.question
                },
                productType: payload.productType
            };

        case ActionTypes.UNHANDLED_ERROR:
            return { ...state, isPosting: false, currentStep: WorkflowStep.UnhandledError };

        case ActionTypes.SET_CCPA_MODEL:
            return { ...state, ccpaModel: { ...payload } };

        case ActionTypes.SUCCESS_FINAL:
            return { ...state, ccpaModel: null, dataSuccess: true, dataFailure: false, isPosting: false };

        case ActionTypes.FULL_FAILURE:
            return { ...state, dataFailure: true, dataSuccess: false, ccpaModel: null, fullFailure: true, isPosting: false };

        case ActionTypes.CLEAR_DATA:
            return { ...state, ccpaModel: null, question: null, conversationId: null };

        default:
            return state;
    }
};

export default appReducers;